// Reine Anzeigeinformation: Message Mappings von Paketen ohne iFlow (Feld designArtifacts der Paketliste).
// Sie fließen weder in Auswahl noch in Payload oder Reducer ein.
const byPackage = new Map();
const keyOf = (instanceId, packageId) => `${instanceId}|${packageId}`;

export function setDesignArtifacts(instanceId, packageId, list) {
  byPackage.set(keyOf(instanceId, packageId), Array.isArray(list) ? list : []);
}

export function getDesignArtifacts(instanceId, packageId) {
  return byPackage.get(keyOf(instanceId, packageId)) || [];
}
